import React from 'react';
import { mergeHelperAndHint, renderQuestionLabel } from '../../utils/common';
import InputTooltip from './InputTooltip';
var Checkbox = function (_a) {
    var label = _a.label, question = _a.question, questionKey = _a.questionKey, value = _a.value, handleChange = _a.handleChange, handleBlur = _a.handleBlur, _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b, _c = _a.error, error = _c === void 0 ? false : _c, helper = _a.helper, hint = _a.hint;
    // Normalize the incoming value to a boolean for the checked state
    var isChecked = value === true ||
        value === 'true' ||
        value === 1 ||
        value === '1';
    return (React.createElement("div", { className: "flex flex-col w-full ".concat(isDisabled ? 'opacity-60' : '') },
        (helper || hint) && (React.createElement("div", { className: "flex justify-end mr-4" },
            React.createElement(InputTooltip, { text: mergeHelperAndHint('helper', 'hint') }))),
        React.createElement("div", { className: "flex items-start gap-3 mt-2" },
            React.createElement("input", { name: questionKey, id: questionKey, type: "checkbox", onChange: function (e) {
                    e.target.value = e.target.checked;
                    handleChange(e);
                }, onBlur: handleBlur, disabled: isDisabled, checked: isChecked, className: "w-5 h-5 mt-1 flex-shrink-0 ".concat(error
                    ? 'appearance-none border-2 border-[#EA4335] bg-[#FBD9D7] rounded-[4px]'
                    : 'accent-primary') }),
            React.createElement("label", { htmlFor: questionKey, className: "text-sm md:text-xl break-words leading-snug font-medium text-left ".concat(error ? 'text-[#EA4335]' : 'text-[#252846]') }, renderQuestionLabel(question === null || question === void 0 ? void 0 : question.isHtml, label)))));
};
export default Checkbox;
